import { render, staticRenderFns } from "./PrivacyStatementView.vue?vue&type=template&id=5db56565&scoped=true&"
import script from "./PrivacyStatementView.vue?vue&type=script&lang=js&"
export * from "./PrivacyStatementView.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyStatementView.vue?vue&type=style&index=0&id=5db56565&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db56565",
  null
  
)

export default component.exports